/* eslint-disable @next/next/no-img-element */
import React from "react";
import * as Icons from "lucide-react";
import styles from "./styles.module.css";

const iconOptions = Object.keys(Icons).map((name) => ({
  label: name,
  value: name,
}));

const CardBlock = {
  label: "Card",
  fields: {
    title: { type: "text", contentEditable: true },
    description: { type: "textarea", contentEditable: true },
    icon: { type: "select", options: iconOptions },
    mode: {
      type: "radio",
      options: [
        { label: "card", value: "card" },
        { label: "flat", value: "flat" },
      ],
    },
  },
  defaultProps: {
    title: "Title",
    description: "Description",
    icon: "Feather",
    mode: "flat",
  },
  render: ({ title, description, icon, mode }) => {
    const Icon = icon && Icons[icon] ? Icons[icon] : null;

    const wrapperClass =
      mode === "card" ? `${styles.Card} ${styles["Card--card"]}` : styles.Card;

    return (
      <div className={wrapperClass}>
        <div className={styles["Card-inner"]}>
          {Icon && (
            <div className={styles["Card-icon"]}>
              <Icon size={64} />
            </div>
          )}
          <div>
            <div className={styles["Card-title"]}>{title}</div>
            <div className={styles["Card-description"]}>{description}</div>
          </div>
        </div>
      </div>
    );
  },
};

export default CardBlock;

